var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tasks.length)?_c('div',{staticClass:"completed"},[_c('div',{staticClass:"completed-title"},[_vm._v("Completed tasks")]),_vm._l((_vm.tasks),function(task){return _c('com-task',{key:task.id,attrs:{"task":task}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }